/* eslint-disable */

import {isFunction, includes} from "lodash";

export class tableSortDirective {
	constructor($filter, $timeout) {
		this.$filter = $filter;
		this.$timeout = $timeout;
		this.restrict = "EA";
		this.translate = (key) => this.$filter("translate")(key);
	}

	link(scope, element, attributes) {

		this.$timeout(() => {
			let parentName, parentScope, headCells;

			parentName = attributes.tableSort;

			try {
				parentScope = scope[attributes.tableSort];
			} catch (e) {
				console.log("Not found parent controller, check is table-sort='parentName' is correct");
				return false;
			}

			headCells = angular.element(element).find("th");

			for (let iterator = 0; iterator < headCells.length; iterator++) {

				let cell, cellValue, cellSortAttr;

				cell = angular.element(headCells[iterator]);
				cellValue = cell.text();
				cellSortAttr = cell[0].getAttribute("data-sort") || cellValue;

				cell.text(this.translate(`${cellValue}`));

				cell.on("click", () => {

					angular.forEach(headCells, th => {
						angular.element(th).removeClass("sort-asc");
						angular.element(th).removeClass("sort-desc");
					});

					parentScope.objects = [];

					parentScope.tableConfiguration.next_uri = null;
					if (parentScope.tableConfiguration.orderCopy == cellSortAttr) {
						parentScope.tableConfiguration.order = "-" + cellSortAttr
					} else {
						parentScope.tableConfiguration.order = cellSortAttr
					}

					angular.element(cell).addClass(includes(parentScope.tableConfiguration.order, "-") ? "sort-asc" : "sort-desc");

					parentScope.tableConfiguration.orderCopy = parentScope.tableConfiguration.order;
					parentScope.$onInit();
				});

			}
		}, 10);

	}

	static create() {
		return new tableSortDirective(...arguments);
	}
}

export class tableSearchDirective {
	constructor($timeout) {
		this.$timeout = $timeout;
		this.restrict = "A";
	}

	link(scope, element, attributes) {

		let parentName, parentScope, _timeout;

		parentName = attributes.tableSearch;

		try {
			parentScope = scope[attributes.tableSearch];
		} catch (e) {
			console.log("Not found parent controller, check is table-search='parentName' is correct");
			return false;
		}


		angular.element(element).on("keydown keyup", (e) => {
			if (_timeout) {
				this.$timeout.cancel(_timeout);
			}
			_timeout = this.$timeout(() => {
				parentScope.tableConfiguration.next_uri = null;
				parentScope.tableConfiguration.search = element.val();
				if (!this.await) {
					this.await = true;
					(element.val() == "" && isFunction(parentScope.$reload)) ?
						parentScope.$reload().then(() => this.await = false) :
						parentScope.$onInit().then(() => this.await = false);
				}
				_timeout = null;
			}, 300);
		});
	}

	static create() {
		return new tableSearchDirective(...arguments);
	}
}

tableSortDirective.create.$inject = ["$filter", "$timeout"];
tableSearchDirective.create.$inject = ["$timeout"];



/** WEBPACK FOOTER **
 ** ./frontend/components/utility/tables.directives.js
 **/